"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _common = require("../../common");
var _ImagePlaceholder = require("../ImagePlaceholder");
var _PlayIcon = require("../PlayIcon");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const Video = ({
  src,
  placeholderHeight,
  placeholderWidth,
  playInLoop,
  appendTimeFragment = true,
  ...htmlDivElementProps
}) => {
  const playerRef = (0, _react.useRef)(null);
  const [isPlaying, setIsPlaying] = (0, _react.useState)(false);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [isPlaceholderVisible, setIsPlaceholderVisible] = (0, _react.useState)(true);
  const toggleVideo = (0, _react.useCallback)(async () => {
    if (playerRef.current) {
      if (isPlaying) {
        playerRef.current.pause();
      } else {
        await playerRef.current.play();
      }
      setIsPlaying(prevState => !prevState);
    }
  }, [isPlaying]);
  const hideImagePlaceholder = (0, _react.useCallback)(() => {
    setIsPlaceholderVisible(false);
  }, []);
  const url = (0, _react.useMemo)(() => {
    if (appendTimeFragment) {
      return (0, _utils.normalizeVideoUrlWithFragment)(src);
    }
    return src;
  }, [src, appendTimeFragment]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ...htmlDivElementProps,
    "data-testid": getTestId(_common.VIDEO),
    children: [isPlaceholderVisible ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PlayButton, {
      "aria-label": "\u23EF\uFE0F",
      isPlaying: isPlaying,
      role: "button",
      tabIndex: 0,
      "data-testid": getTestId(_common.VIDEO_PLAY_BUTTON),
      onClick: toggleVideo,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlayIcon.PlayIcon, {
        isInteractive: true
      })
    }), isPlaceholderVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePlaceholder.ImagePlaceholder, {
      isLoadingPlaceholder: true,
      isSquare: placeholderHeight === undefined && placeholderWidth === undefined,
      height: placeholderHeight,
      width: placeholderWidth
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Player, {
      ref: playerRef,
      "aria-hidden": true,
      muted: true,
      playsInline: true,
      loop: playInLoop,
      src: url,
      isPlaceholderVisible: isPlaceholderVisible,
      "data-testid": getTestId(_common.VIDEO_PLAYER),
      onClick: toggleVideo,
      onLoadedData: hideImagePlaceholder
    })]
  });
};
exports.Video = Video;
